module.exports = __webpack_public_path__ + "media/coral.f3b87a47.webm";